
const initialState = () => ({
    isEdit: false,
    spliting: false,
    SE_DATE: new Date(),
    bill_form: {
        BILL_ID: "",
        QUOTATION_ID: "",
        CUSTOMER_ID: Number,
        CUSTOMER_NAME: "",
        CUSTOMER_TAX_ID: "",
        CUSTOMER_BRANCH: "",
        CUSTOMER_ADDRESS: "",
        PROVIDER_EMAIL: "",
        CUSTOMER_SUBDISTRICT: "",
        CUSTOMER_DISTRICT: "",
        CUSTOMER_PROVINCE: "",
        CUSTOMER_ZIPCODE: "",
        
        CUSTOMER_PHONE: "",
        CUSTOMER_NEWPHONE: "",

        PRICE_OPTION: "",
        ISVAT: "",
        ISVAT2: "",
        MEMO: "",
        REMARK: "",
        CREATED_AT: "",
        TOTAL_PRICE: 0,
        VAT_VALUE: "",
        VAT_VALUE2: "",
        TOTAL: 0,
        DOC_DATE: "",
        SIGNATURE: "",
        SPLIT_PAY: "",
        SPLIT_VALUE: "",
        PREVIOUS_VALUE: "",
        TEMP_PREVIOUS_VALUE: "",
        PAID_VAT:"",
        DOC_STATUS:"",
        IS_CONTRACT:true,
        STATUS:"",
        PAID_NO_VAT:"",
        SPLIT_OPTION: ""
    },
    PRODUCT_LIST: [
        {
            PID: 0,
            QID: "",
            NAME: "",
            DETAIL: "",
            AMOUT: 1,
            UNIT: "",
            PRICE: 0,
            TOTAL_PRICE: 0
        },
    ]
});

const state = initialState()


const getters = {
    GET_BILL: state => state.bill_form,
    GET_SE_DATE: state => state.SE_DATE,
    GET_PRODUCT: state => state.PRODUCT_LIST,
    IS_EDIT: state => state.isEdit,
    SPLITING: state => state.spliting,

}

const mutations = {
    SET_IS_EDIT(state, data) {
        state.isEdit = data
    },
    SET_SPLITING(state, data) {
        state.spliting = data
    },
    SET_ALL_ELEMENT(state, data) {
        state.bill_form = Object.assign({}, data);
    },
    MERGE_ALL_ELEMENT(state, data) {
        let object1 = state.bill_form
        state.bill_form = Object.assign(object1, data);
    },
    SET_ELEMENT(state, data) {
        state.bill_form[data.key] = data.value;
    },
    SET_SE_DATE(state, data) {
        state.SE_DATE = data
    },
    SET_PRODUCT_LIST(state, data) {
        state.PRODUCT_LIST = data
    },
    RESET(state) {
        const newState = initialState();
        Object.keys(newState).forEach(key => {
            state[key] = newState[key]
        });
    },

}

const actions = {
    remove_product_list(context, items) {
        let data = context.state.PRODUCT_LIST
        const index = data.indexOf(items)
        data.splice(index, 1);
        context.commit('SET_PRODUCT_LIST', data)
    },
    add_product_list(context, items) {
        let data = context.state.PRODUCT_LIST
        data.push(items)
        data[data.length - 1].INDEX = parseInt(data.length) - 1
        context.commit('SET_PRODUCT_LIST', data)
    },
    reset_product_list(context, items) {
        context.commit('SET_PRODUCT_LIST', [{
            INDEX: 0,
            NAME: "",
            DETAIL: "",
            AMOUT: 1,
            UNIT: "",
            PRICE: 0,
            TOTAL_PRICE: 0
        }])
    },
    reset({ commit }) {
        commit('RESET');
    }
}
// Mutations

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}